var fn = function( obj ){
var __t,__p='';
__p+='\n  #if HAS_AmbientMultiplier\n    diffuseContrib *= vec3(AmbientMultiplier());\n  #endif\n\n\n  #if HAS_Lightmap\n    vec3 lightmap = pow( Lightmap(), vec3(LightmapGamma()) );\n    // vec3 lightmap = Lightmap();\n    // gi = gi * .1 + .9;\n\n    #if HAS_LightmapMultiplier\n      lightmap = lightmap * LightmapMultiplier();\n    #endif\n\n    diffuseContrib += lightmap;\n    // specularColor *= gi;\n  #endif';
return __p;
};
fn.toString=fn;
module.exports = fn;